import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { useQuery } from "react-query";
import { DownloadOneToOneReportApi, OneToOneReportApi, UserListApi } from "../../Api";
import { AxiosResponse } from "axios";
import { RenderPaginationButtons } from "../../../Components/Paginations";
import { useLocation, useNavigate } from "react-router-dom";
import { useRole } from "../../store";
import { IoMdArrowRoundBack } from "react-icons/io";


interface ReportDataType {
    number: string,
    campaign_name: string,
    user: {
        name: string,
        email: string,
        role: number
    }
}

export default function UserOneToOneReport() {
    const [Data, setData] = useState<ReportDataType[]>([]);
    const isMonitor = useRole((state) => state.isMonitor)
    const { state } = useLocation();
    const [users, setUsers] = useState<{ id: number; name: string }[]>([]);
    const navigate = useNavigate();

    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [Filter, setFilter] = useState<{
        user_id: null | number;
        number: string;
    }>({
        user_id: null,
        number: "",
    });
    const [page, setPage] = useState(1);

    const userList = useQuery({
        queryKey: ["User-List-API"],
        queryFn: UserListApi,
        onSuccess: (resp: AxiosResponse) => {
            setUsers(resp.data?.users || []);
        },
        enabled: false,
    });

    const Report = useQuery({
        queryKey: ["One-To-One-Report", state?.id, page, Filter],
        queryFn: OneToOneReportApi,
        onSuccess: (resp: AxiosResponse) => {
            setData(resp.data?.data || []);
            setPage(resp.data?.info?.current_page || 1);
            setInfo(resp?.data?.info);
        },
        enabled: false,
    });

    const ReportDownload = useQuery({
        queryKey: ["One-To-One-Report-Download", state?.id, page, Filter],
        queryFn: DownloadOneToOneReportApi,
        onSuccess: (resp: AxiosResponse) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(resp.data)
            link.download = `One_To_One_Report_${new Date().toISOString()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        enabled: false,
    });

    useEffect(() => {
        if (!state?.id) navigate("/report/one-to-one/campaign-list");
        Report.refetch();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (isMonitor) userList.refetch();
        // eslint-disable-next-line
    }, [isMonitor])

    useEffect(() => {
        Report.refetch();
        // eslint-disable-next-line
    }, [page]);

    useEffect(() => {
        const handler = setTimeout(() => {
            Report.refetch();
        }, 300);

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Filter.number, Filter.user_id]);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
        }
    };

    const handleClearSearchFilter = () => {
        setFilter({
            user_id: null,
            number: "",
        });
        Report.refetch();
    };

    return (
        <section className="content">
            <div className="container-fluid">
                <div className="card mt-4">
                    <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                        <div className="d-flex justify-content-between w-100 flex-wrap gap-3">
                            <h2 className="mb-0 fs-3 d-block d-md-inline">One To One Report</h2>
                            <div className="d-flex gap-3 flex-wrap flex-grow-1 flex-md-grow-0">
                                <button
                                    onClick={handleClearSearchFilter}
                                    className="btn btn-secondary d-flex align-items-center justify-content-center gap-2"
                                    style={{ minWidth: 130 }}
                                >
                                    <MdClear className="fs-5" />
                                    Clear Filter
                                </button>
                                <button
                                    onClick={() => ReportDownload.refetch()}
                                    style={{ minWidth: 130 }}
                                    className="btn btn-success d-flex align-items-center justify-content-center gap-2 text-white"
                                    disabled={ReportDownload.isFetching}
                                >
                                    <BiExport className="fs-5" />
                                    {ReportDownload.isFetching ? "Exporting.." : "Export"}

                                </button>
                                <button
                                    onClick={() => navigate(-1)}
                                    className="btn btn-info text-white d-flex align-items-center fw-semibold"
                                >
                                    <IoMdArrowRoundBack /> Back
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body border-start-0 border-end-0 p-0">
                        <div className="table-responsive" style={{ minHeight: 500 }}>
                            <table className="table table-hover table-bordered text-nowrap">
                                <thead>
                                    <tr>
                                        <th style={{ width: 200 }}>SR No</th>
                                        <th style={{ width: 250 }}>Number</th>
                                        <th style={{ minWidth: 350 }}>User</th>
                                        <th style={{ width: 250 }}>Role</th>
                                        <th>Campaign</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.number}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, number: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            {isMonitor ?
                                                <select
                                                    style={{ width: 240 }}
                                                    value={Filter.user_id || ""}
                                                    className="form-control w-100"
                                                    onChange={(e) => {
                                                        if (e.target.value === "All")
                                                            return setFilter({ ...Filter, user_id: null });
                                                        setFilter({
                                                            ...Filter,
                                                            user_id: Number(e.target.value),
                                                        });
                                                    }}
                                                >
                                                    <option value="All">All</option>
                                                    {users?.map((item, i) => (
                                                        <option key={i} value={item?.id?.toString()}>
                                                            {item?.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                : null}
                                        </th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Data && Data[0] ? (
                                        Data.map((item, i) => (
                                            <tr>
                                                <td>{i + 1 + (page - 1) * 10}</td>
                                                <td>{item?.number || " - "}</td>
                                                <td>
                                                    <p className="mb-0">{item?.user?.name}</p>
                                                    <p className="mb-0">
                                                        <small>{item?.user?.email}</small>
                                                    </p>
                                                </td>
                                                <td>{item?.user?.role === 1 ? "Agent" : item?.user?.role === 2 ? "Monitor" : " - "}</td>
                                                <td>{item?.campaign_name || " - "}</td>
                                            </tr>
                                        ))
                                    ) : !Report.isFetching ? (
                                        <tr>
                                            <td colSpan={6} height={50}>
                                                <div className="text-center">
                                                    <p className="mb-0 fs-5 fw-semibold">
                                                        No data found
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                            {Report.isFetching ? (
                                <center className="mb-3">
                                    <i
                                        className=" my-2 fa loader"
                                        style={{ fontSize: "30px", color: "black" }}
                                    ></i>
                                </center>
                            ) : null}
                        </div>
                        {info && info.total_page ? (
                            <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                <RenderPaginationButtons
                                    info={info}
                                    currentPage={page}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
}
